export const text =
  '【2024 TiDB 社区用户案例合集白皮书】集结 40+ 金融、互联网、零售、制造、物流、游戏行业用户全场景实践！';
export const link = 'https://asktug.com/t/topic/1038427'
